import React, { useEffect } from 'react'
import './introduction.css'
// import img from '../../assets/backgroundimages/img1.png'
import img from '../../assets/Images/Img2.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import ReactGA from 'react-ga';


const Introduction = () => {

  useEffect(()=>{
    AOS.init({ duration: 1000 });
  })
  const handleClick=()=>{
    ReactGA.event({'category':'Resume','action':'open','label':'label'});
 }

  return (
    <div className="introductionSection row overflow" id="about">
      <div className="introductionRightSide col-lg-6 col-md-12 rightleftSide" data-aos="fade-right">
        <div className="introduction_image image">
          <img src={img} alt="" />
        </div>
      </div>
      <div className="introductionLeftSide  col-lg-6 col-md-12 aos" >
        <h3 className='sectionIntro' data-aos="fade-left">About Me:</h3>
        <p data-aos="fade-left">
        "Hello, and welcome to my portfolio! My name is Nilesh Lad, and I'm a web developer with a passion for creating websites. This portfolio showcases some of my favorite projects, which range from Movie library to text analyzer. Each project demonstrates my skills and creativity, and I'm excited to share them with you.
        </p>
        <p data-aos="fade-left">
        Feel free to explore my portfolio and get in touch if you're interested in working together. Whether you're looking for a new website, an e-commerce platform, or a custom web application, I'm here to help. I take pride in using the latest technologies and techniques to deliver high-quality web applications that meet my clients' needs. Thank you for visiting!"
        </p>
        
        <a href="https://drive.google.com/file/d/1AcEuySIau_5hV59v9wKZghtVIhCPGtQE/view" rel="noreferrer noopener" target="_blank" onClick={handleClick}>
            <div  className="resume_btn introBtn">
              <div className="resume_button-wrapper">
                <div className="text">Resume</div>
                <span className="icon">
                  <svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" height="2em" width="2em" role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" stroke="currentColor" fill="none"></path></svg>
                </span>
              </div>
            </div>
            </a>
        
      </div>
    </div>
  )
}

export default Introduction